export enum REACTIONS_TYPES {
  Likes = "likes",
  Matches = "matches",
  UserRating = "userRating",
}
